import { getFlowError } from '../constants/flowErrors.js';
import { statusOptions } from '../constants/appConstants.js';

export const compareByCriteria = (a, b, groupedDataByUnit) => {
  // First criteria: unit_status ("active" first, "disabled" last)
  if (a.unit_status !== b.unit_status) {
    return a.unit_status === "active" ? -1 : 1;
  }

  // Second criteria: units with issues first
  const aHasIssues = !!groupedDataByUnit[a.unit];
  const bHasIssues = !!groupedDataByUnit[b.unit];

  if (aHasIssues !== bHasIssues) {
    return aHasIssues ? -1 : 1;
  }

  // Third criteria: unitId (ascending)
  return a.unit?.toString().localeCompare(b.unit?.toString(), undefined, { numeric: true });
};

export const filterDashboardUnits = (dashboardData, filters, data) => {
  const { unitIdFilter, organizationFilter, centerFilter, selectedStatusesFilter } = filters;

  // Convert statusOptions to a map for easier lookup
  const statusMap = Object.fromEntries(
    statusOptions.map(option => [option.value, option.value])
  );
  
  return Object.values(dashboardData).filter((item) => {
    if (unitIdFilter !== '' && !item.unit?.toString().toLowerCase().startsWith(unitIdFilter.toLowerCase())) {
      return false;
    }
    if (organizationFilter && item.organization?.toLowerCase() !== organizationFilter.toLowerCase()) {
      return false;
    }
    if (centerFilter && item.center?.toLowerCase() !== centerFilter.toLowerCase()) {
      return false;
    }
    if (selectedStatusesFilter.length > 0) {
      const unitStates = [];
      
      if (item.unit_status === "disabled") {
        unitStates.push(statusMap.disabled);
      } else {
        if (item.daily_unit_use === 0 || item.daily_unit_use === "") {
          unitStates.push(statusMap.unused);
        }
        if (item.isUnitDisconnected) {
          unitStates.push(statusMap.disconnected);
        }
        if (item.clogged === true) {
          unitStates.push(statusMap.clogged);
        }
        // Use centralized flow error checking
        const hasLoopedError = data.some(issue => {
          const flowError = getFlowError(issue.Issue?.ID);
          return issue.Installation?.Unit_ID === item.unit && 
                 flowError?.type === 'looped';
        });
        if (hasLoopedError) {
          unitStates.push(statusMap.looped);
        }

        // Check both the isUnitStuck flag and flow errors for stuck status
        if (item.isUnitStuck === true) {
          unitStates.push(statusMap.stuck);
        }
      }

      const selectedValues = selectedStatusesFilter.map(opt => opt.value);
      const hasMatch = selectedValues.some(val => unitStates.includes(val));
      if (!hasMatch) return false;
    }

    return true;
  });
};